<template>
  <!-- 对话框 -->
  <el-dialog
    width="70%"
    top="2vh"
    :visible.sync="show"
    :before-close="closeDialog"
    :close-on-click-modal="false"
  >
    <div style="height: 72vh; overflow-y: auto">
      <!-- 高德地图 -->
      <div id="container_add"></div>
      <!-- 高德地图功能组件 -->
      <div class="form-box">
        <el-form ref="form">
          <el-form-item
            label=""
            label-width="125px"
          >
            <el-switch
              v-model="submit_data.coordinate_type"
              active-value="1"
              inactive-value="0"
              active-text="开启"
              inactive-text="关闭"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label=""
            label-width="50px"
          >
            <el-button
              type="success"
              @click="coordinateInit"
              style="display: block; margin: 0 auto 20px"
            >初始化围栏
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <!-- 对话框底部按钮 -->
    <span
      slot="footer"
      class="dialog-footer"
    >
      <submitBtn
        :data="submit_data"
        :rules="submit_rules"
        url="/order/editModeCoordinateSubmit"
        @onSubmitDig="onSubmitDig"
        :JSON_Boolean="false"
      />

      <el-button @click="closeDialog">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
var _this,
    district,
    map,
    free_area_coordinate_array,
    far_area_coordinate_array,
    effective_area_coordinate_array,
    free_area_polygon,
    far_area_polygon,
    effective_area_polygon,
    free_area_polyEditor,
    far_area_polyEditor,
    effective_area_polyEditor;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            // _this.submit_data.city_tag = JSON.parse(
            //     localStorage.getItem("city_tag")
            // ).city_tag;
            _this.submit_data.order_mode_code = _this.data;
            _this.$nextTick(function () {
                // 地图加载完成后
                _this.mapinit().then((res) => {
                    // 获取订单模式详情
                    _this
                        .$post('/order/getOrderModeDetails', {
                            order_mode_code: _this.data,
                            city_code: JSON.parse(localStorage.getItem('login')).city.city_code
                        })
                        .then((res) => {
                            _this.submit_data.coordinate_type = res.data.coordinate_type;

                            _this.submit_data.free_area_coordinate_array = res.data.free_area_coordinate_array;
                            _this.submit_data.far_area_coordinate_array = res.data.far_area_coordinate_array;
                            _this.submit_data.effective_area_coordinate_array = res.data.effective_area_coordinate_array;
                            console.log(JSON.parse(res.data.free_area_coordinate_array));

                            if (res.data.free_area_coordinate_array != null) {
                                free_area_coordinate_array = JSON.parse(res.data.free_area_coordinate_array);
                                // 一小时围栏的初始化设置
                                free_area_polygon = new AMap.Polygon({
                                    path: free_area_coordinate_array,
                                    strokeColor: '#008000',
                                    strokeWeight: 6,
                                    strokeOpacity: 0.5,
                                    fillOpacity: 0.4,
                                    fillColor: '',
                                    zIndex: 50
                                });
                                // 添加一小时围栏
                                map.add(free_area_polygon);
                                //一小时围栏画线
                                free_area_polyEditor = new AMap.PolyEditor(map, free_area_polygon);
                                free_area_polyEditor.open();

                                console.log(free_area_polyEditor,'一小时围栏触对象');
                                //改变一小时围栏触发
                                free_area_polyEditor.on('adjust', function (event) {
                                    let free_area_coordinate_array = event.target.getPath();
                                    var free_area_array = [];

                                    // 遍历将free_area_coordinate_array的坐标值存到free_area_array数组中
                                    for (let i = 0; i < free_area_coordinate_array.length; i++) {
                                        free_area_array.push([free_area_coordinate_array[i].lng, free_area_coordinate_array[i].lat]);
                                    }
                                    console.log(free_area_array);
                                    _this.submit_data.free_area_coordinate_array = JSON.stringify(free_area_array);
                                });
                                free_area_polyEditor.on('addnode', function (event) {
                                    let free_area_coordinate_array = event.target.getPath();
                                    var free_area_array = [];

                                    // 遍历将free_area_coordinate_array的坐标值存到free_area_array数组中
                                    for (let i = 0; i < free_area_coordinate_array.length; i++) {
                                        free_area_array.push([free_area_coordinate_array[i].lng, free_area_coordinate_array[i].lat]);
                                    }
                                    console.log(free_area_array);
                                    _this.submit_data.free_area_coordinate_array = JSON.stringify(free_area_array);
                                });
                            }

                            if (res.data.far_area_coordinate_array != null) {
                                // 超远围栏做标组
                                far_area_coordinate_array = JSON.parse(res.data.far_area_coordinate_array);
                                // 超远围栏的初始化设置
                                far_area_polygon = new AMap.Polygon({
                                    path: far_area_coordinate_array,
                                    strokeColor: '#FF33FF',
                                    strokeWeight: 6,
                                    strokeOpacity: 0.5,
                                    fillOpacity: 0.4,
                                    fillColor: '',
                                    zIndex: 50
                                });
                                // 添加超远围栏
                                map.add(far_area_polygon);
                                //超远围栏画线
                                far_area_polyEditor = new AMap.PolyEditor(map, far_area_polygon);
                                far_area_polyEditor.open();
                                //改变超远围栏触发
                                far_area_polyEditor.on('adjust', function (event) {
                                    let far_area_coordinate_array = event.target.getPath();
                                    var far_area_array = [];

                                    // 遍历将path的坐标值存到polygon2_path数组中
                                    for (let i = 0; i < far_area_coordinate_array.length; i++) {
                                        far_area_array.push([far_area_coordinate_array[i].lng, far_area_coordinate_array[i].lat]);
                                    }

                                    _this.submit_data.far_area_coordinate_array = JSON.stringify(far_area_array);
                                });

                                far_area_polyEditor.on('addnode', function (event) {
                                    let far_area_coordinate_array = event.target.getPath();
                                    var far_area_array = [];

                                    // 遍历将path的坐标值存到polygon2_path数组中
                                    for (let i = 0; i < far_area_coordinate_array.length; i++) {
                                        far_area_array.push([far_area_coordinate_array[i].lng, far_area_coordinate_array[i].lat]);
                                    }

                                    _this.submit_data.far_area_coordinate_array = JSON.stringify(far_area_array);
                                });
                            }

                            if (res.data.effective_area_coordinate_array != null) {
                                // 有效围栏坐标组
                                effective_area_coordinate_array = JSON.parse(res.data.effective_area_coordinate_array);
                                // 有效围栏的初始化设置
                                effective_area_polygon = new AMap.Polygon({
                                    path: effective_area_coordinate_array,
                                    strokeColor: '#000000',
                                    strokeWeight: 6,
                                    strokeOpacity: 0.5,
                                    fillOpacity: 0.4,
                                    fillColor: '',
                                    zIndex: 50
                                });
                                // 添加有效围栏
                                map.add(effective_area_polygon);
                                //有效围栏画线
                                effective_area_polyEditor = new AMap.PolyEditor(map, effective_area_polygon);
                                effective_area_polyEditor.open();
                                //改变有效围栏触发
                                effective_area_polyEditor.on('adjust', function (event) {
                                    var effective_area_array = [];

                                    // 遍历将path的坐标值存到polygon2_path数组中
                                    for (let i = 0; i < effective_area_coordinate_array.length; i++) {
                                        console.log(effective_area_coordinate_array);
                                        effective_area_array.push([
                                            effective_area_coordinate_array[i].lng,
                                            effective_area_coordinate_array[i].lat
                                        ]);

                                        console.log(effective_area_array, '-=-----');
                                    }

                                    _this.submit_data.effective_area_coordinate_array = JSON.stringify(effective_area_array);

                                    console.log(_this.submit_data.effective_area_coordinate_array);
                                });
                                //改变有效围栏触发
                                effective_area_polyEditor.on('addnode', function (event) {
                                    let effective_area_coordinate_array =event.target.getPath();
                                    var effective_area_array = [];

                                    // 遍历将path的坐标值存到polygon2_path数组中
                                    for (let i = 0; i < effective_area_coordinate_array.length; i++) {
                                        console.log(effective_area_coordinate_array);
                                        effective_area_array.push([
                                            effective_area_coordinate_array[i].lng,
                                            effective_area_coordinate_array[i].lat
                                        ]);

                                        console.log(effective_area_array, '-=-----');
                                    }

                                    _this.submit_data.effective_area_coordinate_array = JSON.stringify(effective_area_array);

                                    console.log(_this.submit_data.effective_area_coordinate_array);
                                });
                            }
                        })
                        .catch((err) => {});
                });
            });
        }
    },
    data() {
        return {
            show: false,

            // 第一页表单数据
            submit_data: {
                order_mode_code: '',
                coordinate_type: '0',
                free_area_coordinate_array: '',
                far_area_coordinate_array: '',
                effective_area_coordinate_array: ''
            },

            submit_rules: {
                order_mode_code: {
                    placeholder: '订单模式唯一编码',
                    rules: {
                        required: true,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                coordinate_type: {
                    placeholder: '状态',
                    rules: {
                        required: true,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                free_area_coordinate_array: {
                    placeholder: '一小时围栏坐标组',
                    rules: {
                        required: false,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                far_area_coordinate_array: {
                    placeholder: '超远围栏坐标组',
                    rules: {
                        required: false,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                effective_area_coordinate_array: {
                    placeholder: '有效围栏坐标组',
                    rules: {
                        required: false,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        async mapinit() {
            // 地图初始化
            map = new AMap.Map('container_add', {
                //初始化地图中心点
                center: [116.397428, 39.90923],
                resizeEnable: true, //是否监控地图容器尺寸变化
                zoom: 13 //初始地图级别
            });

            var loginCityName = JSON.parse(localStorage.getItem('login')).city.name;

            var x = loginCityName.indexOf('/');

            for (var i = 0; i < 1; i++) {
                x = loginCityName.indexOf('/', x + 1);
            }

            // 如果为市级
            if (x < 0) {
                // 截取城市名称 如:XXXX / 截取字段
                var city_name = loginCityName.slice(loginCityName.indexOf('/') + 2);
            } else {
                // 截取城市名称 如:XXXX / XXXX / 截取字段
                var city_name = loginCityName.slice(x + 2);
            }
            console.log(city_name);
            // 设置地图中心点
            map.setCity(city_name);
        },

        // 初始化围栏按钮
        coordinateInit() {
            var mapCenter = map.getCenter();
            // console.log(free_area_polyEditor, '111');

            console.log(far_area_polyEditor);
            // console.log(effective_area_polygon);
            if (free_area_polyEditor) {
                console.log(3331);
                free_area_polyEditor.close();

                _this.submit_data.free_area_coordinate_array = '';
            }

            if (far_area_polyEditor) {
                console.log(3332);
                far_area_polyEditor.close();

                _this.submit_data.far_area_coordinate_array = '';
            }

            if (effective_area_polyEditor) {
                console.log(3333);
                effective_area_polyEditor.close();

                _this.submit_data.effective_area_coordinate_array = '';
            }

            if (free_area_polygon) {
                // 移除一小时围栏
                map.remove(free_area_polygon);
            }

            if (far_area_polygon) {
                // 移除超远围栏
                map.remove(far_area_polygon);
            }

            if (effective_area_polygon) {
                // 移除有效围栏
                map.remove(effective_area_polygon);
            }

            // 一小时围栏做标组
            free_area_coordinate_array = [
                [mapCenter.lng + 0.03, mapCenter.lat],
                [mapCenter.lng - 0.03, mapCenter.lat - 0.03],
                [mapCenter.lng - 0.03, mapCenter.lat + 0.03]
            ];

            // 超远围栏做标组
            far_area_coordinate_array = [
                [mapCenter.lng + 0.06, mapCenter.lat],
                [mapCenter.lng - 0.06, mapCenter.lat - 0.06],
                [mapCenter.lng - 0.06, mapCenter.lat + 0.06]
            ];

            // 有效围栏坐标组
            effective_area_coordinate_array = [
                [mapCenter.lng + 0.09, mapCenter.lat],
                [mapCenter.lng - 0.09, mapCenter.lat - 0.09],
                [mapCenter.lng - 0.09, mapCenter.lat + 0.09]
            ];

            // 一小时围栏的初始化设置
            free_area_polygon = new AMap.Polygon({
                path: free_area_coordinate_array,
                strokeColor: '#008000',
                strokeWeight: 6,
                strokeOpacity: 0.5,
                fillOpacity: 0.4,
                fillColor: '',
                zIndex: 50
            });

            // 超远围栏的初始化设置
            far_area_polygon = new AMap.Polygon({
                path: far_area_coordinate_array,
                strokeColor: '#FF33FF',
                strokeWeight: 6,
                strokeOpacity: 0.5,
                fillOpacity: 0.4,
                fillColor: '',
                zIndex: 50
            });

            // 有效围栏的初始化设置
            effective_area_polygon = new AMap.Polygon({
                path: effective_area_coordinate_array,
                strokeColor: '#000000',
                strokeWeight: 6,
                strokeOpacity: 0.5,
                fillOpacity: 0.4,
                fillColor: '',
                zIndex: 50
            });

            // 添加一小时围栏
            map.add(free_area_polygon);

            // 添加超远围栏
            map.add(far_area_polygon);

            // 添加有效围栏
            map.add(effective_area_polygon);

            // 缩放地图到合适的视野级别
            map.setFitView([free_area_polygon], true);

            //一小时围栏画线
            free_area_polyEditor = new AMap.PolyEditor(map, free_area_polygon);
            free_area_polyEditor.open();

            //超远围栏画线
            far_area_polyEditor = new AMap.PolyEditor(map, far_area_polygon);
            far_area_polyEditor.open();

            //有效围栏画线
            effective_area_polyEditor = new AMap.PolyEditor(map, effective_area_polygon);
            effective_area_polyEditor.open();

            //改变一小时围栏触发
            free_area_polyEditor.on('adjust', function (event) {
                console.log(free_area_coordinate_array);
                let free_area_coordinate_array = event.target.getPath();
                var free_area_array = [];

                // 遍历将free_area_coordinate_array的坐标值存到free_area_array数组中
                for (let i = 0; i < free_area_coordinate_array.length; i++) {
                    free_area_array.push([free_area_coordinate_array[i].lng, free_area_coordinate_array[i].lat]);
                }

                _this.submit_data.free_area_coordinate_array = JSON.stringify(free_area_array);
            });
            //改变一小时围栏触发
            free_area_polyEditor.on('addnode', function (event) {
                console.log('调整折线上某个点时触发此事件');
                let free_area_coordinate_array = event.target.getPath();
                var free_area_array = [];

                // 遍历将free_area_coordinate_array的坐标值存到free_area_array数组中
                for (let i = 0; i < free_area_coordinate_array.length; i++) {
                    free_area_array.push([free_area_coordinate_array[i].lng, free_area_coordinate_array[i].lat]);
                }

                _this.submit_data.free_area_coordinate_array = JSON.stringify(free_area_array);
            });

            //改变超远围栏触发
            far_area_polyEditor.on('adjust', function (event) {
                let far_area_coordinate_array = event.target.getPath();
                var far_area_array = [];

                // 遍历将path的坐标值存到polygon2_path数组中
                for (let i = 0; i < far_area_coordinate_array.length; i++) {
                    far_area_array.push([far_area_coordinate_array[i].lng, far_area_coordinate_array[i].lat]);
                }

                _this.submit_data.far_area_coordinate_array = JSON.stringify(far_area_array);
            });
            //改变超远围栏触发
            far_area_polyEditor.on('addnode', function (event) {
                let far_area_coordinate_array = event.target.getPath();
                var far_area_array = [];

                // 遍历将path的坐标值存到polygon2_path数组中
                for (let i = 0; i < far_area_coordinate_array.length; i++) {
                    far_area_array.push([far_area_coordinate_array[i].lng, far_area_coordinate_array[i].lat]);
                }

                _this.submit_data.far_area_coordinate_array = JSON.stringify(far_area_array);
            });

            //改变有效围栏触发
            effective_area_polyEditor.on('adjust', function (event) {
                let effective_area_coordinate_array = event.target.getPath();
                var effective_area_array = [];

                // 遍历将path的坐标值存到polygon2_path数组中
                for (let i = 0; i < effective_area_coordinate_array.length; i++) {
                    effective_area_array.push([effective_area_coordinate_array[i].lng, effective_area_coordinate_array[i].lat]);
                }

                _this.submit_data.effective_area_coordinate_array = JSON.stringify(effective_area_array);
            });
            //改变有效围栏触发
            effective_area_polyEditor.on('addnode', function (event) {
                let effective_area_coordinate_array = event.target.getPath();
                var effective_area_array = [];

                // 遍历将path的坐标值存到polygon2_path数组中
                for (let i = 0; i < effective_area_coordinate_array.length; i++) {
                    effective_area_array.push([effective_area_coordinate_array[i].lng, effective_area_coordinate_array[i].lat]);
                }

                _this.submit_data.effective_area_coordinate_array = JSON.stringify(effective_area_array);
            });

        },

        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');

            _this.closeDialog();
        },

        closeDialog() {
            console.log(111);
            _this.show = false;
            free_area_polygon = undefined;
            far_area_polygon = undefined;
            effective_area_polygon = undefined;
            free_area_polyEditor = undefined;
            far_area_polyEditor = undefined;
            effective_area_polyEditor = undefined;
            _this.submit_data = {
                order_mode_code: '',
                coordinate_type: '0',
                free_area_coordinate_array: '',
                far_area_coordinate_array: '',
                effective_area_coordinate_array: ''
            };
        }
    }
};
</script>

<style scoped>
/* 高德地图css */
/* @import "https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css";
    @import "https://a.amap.com/jsapi_demos/static/demo-center/css/prety-json.css"; */

#container_add {
    height: 90%;
    width: 65%;
    float: left;
}

.form-box {
    width: 35%;
    padding: 20px;
    box-sizing: border-box;
    float: left;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
</style>
